import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Record } from 'pkg/api/models/record';

export enum AttendanceStatuses {
	Attended = 'attended',
	Unset = 'unset',
	Injured = 'injured',
	Sick = 'sick',
	Other = 'other',
	NotFitToPlay = 'not_fit_to_play',
	School = 'school',
	Work = 'work',
	Travel = 'travel',
	TechnicalDecision = 'technical_decision',
	Suspended = 'suspended',
	Permission = 'permission',
	PlayingForAnotherTeam = 'playing_for_another_team',
	SelectedForRepresentativeTeam = 'selected_for_representative_team',
}

export enum DeclinedReasonGroup {
	All = 'all',
	Health = 'health',
	Obligations = 'obligations',
	TeamRelated = 'teamRelated',
	Other = 'other',
}

export enum EventUserStatus {
	Pending = 'pending',
	Accepted = 'accepted',
	Declined = 'declined',
}

export enum EventUserFlags {
	LokHasHandicap = 'lok_has_handicap',
	LokLeader = 'lok_leader',
}

export enum EventUserRole {
	Organizer = 'organizer',
	Participant = 'participant',
}

export interface EventUser extends Record, AllowedActionable {
	eventId: number;
	comment: string;
	userId: number;
	attendanceReporterId: number;
	attendanceLastUpdated: number;

	attendanceStatus: AttendanceStatuses;
	status: EventUserStatus;
	flags: EventUserFlags[];
	role: EventUserRole;

	user: models.user.User;
	attendanceReporter: models.user.User;
}
